import dataServices from '@/shared/api/dataServices';
// import { set } from 'lodash';

import {
  GET_HOME
} from '../mutation-types';

export const state = () => ({
  home: {}
});

const mutations = {
  [GET_HOME](state, homeData) {
    state.home = homeData;
  }
};

const actions = {
  async getHomeDataAction({ commit }) {
    const homeData = await dataServices.getHomeData();
    commit(GET_HOME, homeData);
  }
};

const getters = {
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
